import ReactDOM from "react-dom/client";
import { StrictMode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { SentryProvider } from "./sentry-ready/SentryProvider.tsx";

import App from "./App.tsx";

import "./styles/main.scss";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <SentryProvider
    config={{
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
      release: import.meta.env.VITE_APP_VERSION,
    }}
  >
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>
  </SentryProvider>,
);
